import { useIsClientOnly } from "@hooks/useIsClientOnly";
import { createEmbed } from "@routes/Article/components/ArticleParagraphElements/storyElement/embed/EmbedFactory";
import { getEmbedType } from "@routes/Article/components/ArticleParagraphElements/utils/helpers";
import { ArticleStoryElementProps } from "@routes/Article/components/ArticleParagraphElements/utils/types";
import parse, { DOMNode, domToReact, Element } from "html-react-parser";

const Embed = ({
  bodyString,
  className,
}: ArticleStoryElementProps): React.ReactElement => {
  const isClientOnly = useIsClientOnly();

  const replaceEmbed = (
    node: DOMNode
  ): string | boolean | void | object | Element | null => {
    if (node.type !== "tag") return;

    const element = node;
    const embedType = getEmbedType(element);

    if (!embedType) return domToReact([node]);

    const replace = (child: DOMNode) =>
      createEmbed(child, embedType, className);

    return <>{domToReact([node], { replace })}</>;
  };

  return (
    <>{isClientOnly ? parse(bodyString, { replace: replaceEmbed }) : null}</>
  );
};

export default Embed;
